var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amap-wrapper"},[_c('el-amap-search-box',{staticClass:"search-box",attrs:{"search-option":_vm.searchOption,"on-search-result":_vm.onSearchResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }